export enum fundGeographicalFocusFormFields {
  nameEn = 'nameEn',
  nameAr = 'nameAr',
}
